import React, { useEffect } from 'react'
import { Field as FieldConf, getFieldLabel } from 'src/config'
import * as types from '../../../types'
import { InputLabel, OutlinedInput } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers';
import { Dayjs } from "dayjs";
import dayjs from "src/dayjs";

const DateTimeField: React.FC<{
    field: FieldConf,
    value?: types.SimpleValue,
    onChange: (value: types.Value) => void,
    disabled?: boolean
    errors?: types.Error[],
    // options?: types.EntityOptions
    multiline?: boolean
}> = ({
    field,
    value,
    onChange,
    disabled = false,
    errors = [],
    // options
    multiline = false
}) => {
        const { name, label, description, required } = field;

        const pickerValue: Dayjs | null = typeof value === "string" && value ? dayjs(value) : null;

        return (
            <DateTimePicker
                label={getFieldLabel(field)}
                value={pickerValue}
                onChange={(newValue) => onChange(newValue ? newValue.toISOString() : '')}
            />
        )
    }

export default DateTimeField;